export default {"src":"/_next/static/media/Meat.0bdb117a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};